import React, { useState } from 'react'
import { message } from 'antd'

//components
import AdjustmentsTable from './AdjustmentsTable'
import AdjustmentsDrawer from './AdjustmentsDrawer'
import InventoryTabsHeader from '../InventoryTabsHeader'
import InventoryTabsContent from '../InventoryTabsContent'
import inventorySrc from '../../inventorySrc'

function AdjustmentsTab(props) {
  const [showDrawer, setShowDrawer] = useState(false)
  const [loading, setLoading] = useState(props.loading)
  const [fetchData, setFetchData] = useState(true)

  const [searchText, setSearchText] = useState('')

  const onSearch = searchText => {
    setSearchText(searchText)
  }

  const saveNewAdjustment = data => {
    setFetchData(false)
    setLoading(true)
    inventorySrc
      .saveAdjustment(data)
      .then(res => {
        if (res.errors && Object.keys(res.errors)?.length > 0) {
          checkErrors(res)
          setLoading(false)
        } else {
          message.success('Información actualizada.')
          setLoading(false)
          setShowDrawer(false)
          setFetchData(true)
        }
      })
      .catch(err => {
        console.log(err)
        message.error('Error al actualizar la información')
        setLoading(false)
      })
  }

  const checkErrors = res => {
    Object.keys(res.errors).map(key => {
      switch (key) {
        case 'description':
          message.error(res.errors[key][0].replace('description', 'Descripción'))
          break
        case 'products':
          message.error(res.errors[key][0].replace('products', 'Productos'))
          break
        default:
          message.error(res.errors[key])
          break
      }
      return null
    })
  }

  return (
    <div>
      <InventoryTabsHeader
        shopsList={props.shopsList}
        selectedOption={props.selectedOption}
        setSelectedOption={option => {
          props.setSelectedOption(option)
        }}
        onSearch={onSearch}
        buttonLabel={'Nuevo ajuste'}
        buttonHandler={() => setShowDrawer(true)}
        createPermissions={30}
        keyTab={props.keyTab}
      />
      <InventoryTabsContent
        fetchData={fetchData}
        loading={loading}
        component={AdjustmentsTable}
        selectedOption={props.selectedOption}
        searchText={searchText}
        keyTab={props.keyTab}
      />
      <AdjustmentsDrawer
        shopsList={props.shopsList}
        closable={(data, request) => {
          if (request === 'save') return saveNewAdjustment(data)
          setShowDrawer(false)
        }}
        loading={loading}
        visible={showDrawer}
      />
    </div>
  )
}

export default AdjustmentsTab

AdjustmentsTab.defaultProps = {
  shopsList: [],
  selectedOption: null,
}
